import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "play-style-icon"
}
const _hoisted_2 = {
  x: "50%",
  y: "50%",
  "text-anchor": "middle",
  "dominant-baseline": "central",
  "font-family": "Noto sans",
  "font-style": "normal",
  "font-size": "18"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("text", _hoisted_2, _toDisplayString(_ctx.PLAY_STYLE_STRING[_ctx.$store.state.pref.playStyle]), 1)
  ]))
}